<script setup>
import { ref, computed } from 'vue';
import { THEMES } from '@/constants';
import { usePage } from '@inertiajs/vue3';

const props = defineProps({
  contentType: {
    type: String,
    default: "content",
    validator: (v) =>
      [
        "content",
        "list",
      ].indexOf(v) !== -1,
  },
});

const page = usePage();
const context = computed(() => page.props?.context);
const theme = context.value.theme;

const style = ref({
  content: "grid grid-cols-4 lg:gap-8",
  list: "max-w-screen-md mx-auto"
});

const headerClasses = computed(() => [
  '',
  theme == THEMES.STUDY_MELB && 'px-8',
]);

const contentClasses = computed(() => [
  '',
  theme == THEMES.STUDY_MELB && 'px-8',
]);
</script>

<template>
  <div class="content-body">
    <div :class="headerClasses">
      <slot name="header" />
    </div>
    <div :class="[style[contentType], contentClasses]">
      <div class="lg:order-first col-span-4 lg:col-span-3">
        <slot name="content" />
      </div>
      <div class="col-span-4 lg:col-span-1">
        <slot name="sidepanel" />
      </div>
    </div>
  </div>
</template>